export class VendorConfigModel {

  VendorConfigListAPI: string = "";
  UpdateAPI: string = "";
  VendorListAPI: string = "";
  PublisherListAPI: string = "";
  JournalListByPublisherIDAPI: string = "";
  VendorConfigByIdAPI: string = "";
  DeleteVendorConfigAPI: string = "";
  UploadKeyFileAPI: string = "";

}
